'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The button that gets clicked for simple editable text fields.

var styles = exports.styles = {
  base: {
    background: 'transparent',
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    borderBottom: '1px dashed currentColor',
    borderRadius: 0,
    color: 'rgba(061,060,057,1)',
    fontSize: '.9em',
    lineHeight: '1.2rem',
    padding: '0',
    textDecoration: 'none',
    textAlign: 'left',
    ':hover': {
      color: 'rgba(130,151,177,1)'
    },
    ':focus': {
      outline: 'none',
      color: 'rgba(130,151,177,1)'
    },
    ':active': {
      outline: 'none',
      color: 'rgba(130,151,177,1)'
    }
  },
  empty: {
    color: 'rgba(189,151,119,1)'
  }
};

function PreviewTextEditable(_ref) {
  var className = _ref.className,
      emptyText = _ref.emptyText,
      title = _ref.title,
      value = _ref.value,
      onClick = _ref.onClick,
      style = _ref.style;

  return _react2.default.createElement(
    'button',
    {
      className: className,
      onClick: onClick,
      style: style,
      title: title,
      type: 'button'
    },
    value || emptyText
  );
}
PreviewTextEditable.defaultProps = {
  className: 'btn btn-secret',
  title: 'Click to edit',
  emptyText: 'Empty',
  value: null
};
PreviewTextEditable.propTypes = {
  className: _propTypes2.default.string,
  emptyText: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object,
  title: _propTypes2.default.string,
  value: _propTypes2.default.string
};

exports.default = (0, _radium2.default)(PreviewTextEditable);


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/FieldViewEditable.js
// module id = 675
// module chunks = 0